// ═══════════════════════════════════════════════════════════════════════════════
// Shared helpers for auto-translated user-entered content display
// ═══════════════════════════════════════════════════════════════════════════════

import { LANGUAGE, type Language } from '@fdh/shared';

export const translationLanguageNameKey = (language: Language): string => {
  if (language === LANGUAGE.ZH_HANT) return 'translation.lang.zhHant';
  if (language === LANGUAGE.ZH_HANS) return 'translation.lang.zhHans';
  if (language === LANGUAGE.EN) return 'translation.lang.en';
  if (language === LANGUAGE.ID) return 'translation.lang.id';
  if (language === LANGUAGE.FIL) return 'translation.lang.fil';
  return 'translation.lang.en';
};

/** Collapse repeated tokens when bilingual originals translate to the same word twice (e.g. "Dapur Dapur"). */
export const collapseRepeatedTranslationTokens = (text: string): string => {
  const trimmed = text.trim();
  if (trimmed === '') {
    return trimmed;
  }
  const tokens = trimmed.split(/\s+/);
  if (tokens.length <= 1) {
    return trimmed;
  }
  const normalized = tokens.map((token) => token.toLowerCase());
  const allSame = normalized.every((token) => token === normalized[0]);
  if (allSame) {
    return tokens[0] ?? trimmed;
  }
  return trimmed;
};

export const resolveTranslatedDisplayText = (
  original: string,
  translated: string | undefined,
  showOriginal: boolean,
): string => {
  const orig = (original ?? '').trim();
  if (showOriginal || !translated?.trim()) {
    return orig;
  }
  return collapseRepeatedTranslationTokens(translated);
};
